export const schemaYaml = () => `schemas:
  - id: "||VARIABLE_KEY_id||"
    name: "||VARIABLE_KEY_name||"
    description: ""
    tableName: "||VARIABLE_KEY_tableName||"
    tableId: "||VARIABLE_KEY_tableId||"
    columns: []`;
export const schemaColumnYaml = () => `indexGroups: []`;
